var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.queryKey)?_c('th',{attrs:{"scope":"col"}},[_c('router-link',{attrs:{"to":{
      name: _vm.$route.name,
      query: {
        sortBy: _vm.queryKey,
        sortOrder: _vm.$route.query.sortBy === _vm.queryKey && _vm.$route.query.sortOrder === 'asc'
          ? 'desc'
          : 'asc',
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n\n    "),(_vm.queryKey && _vm.$route.query.sortBy === _vm.queryKey)?_c('span',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.$route.query.sortOrder === 'desc'
      ? 'arrow_drop_down'
      : 'arrow_drop_up'))]):_vm._e()])],1):_c('th',{attrs:{"scope":"col"}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }